import { createFileRoute } from "@tanstack/react-router";
import { bookingsListSearchSchema } from "@/features/bookings/bookings-search";
import { requireAuth } from "@/lib/auth-guard";

export const Route = createFileRoute("/bookings/")({
  beforeLoad: requireAuth,
  validateSearch: bookingsListSearchSchema,
});
